module.exports = __webpack_public_path__ + "static/img/zt1-4.ef97fbe.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/layout/zt1-4.png
// module id = 744
// module chunks = 0